import { createSelectorCreator, defaultMemoize } from 'reselect';
import { get, isEqual } from 'lodash';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export const getValuesSelector = (name: string, reducer: string = 'form') =>
  createDeepEqualSelector(
    [(state) => get(state, `${reducer}.${name}.values`)],
    (values) => values
  );

export const getInitialValuesSelector = (
  name: string,
  reducer: string = 'form'
) =>
  createDeepEqualSelector(
    [(state) => get(state, `${reducer}.${name}.initialValues`)],
    (values) => values
  );

export const getDataSelector = (name: string, reducer: string = 'form') =>
  createDeepEqualSelector(
    [(state) => get(state, `${reducer}.${name}.data`)],
    (values) => values
  );

export const getDataByKeySelector = (name: string, reducer: string = 'form') =>
  createDeepEqualSelector(
    [
      (state) => get(state, `${reducer}.${name}.data`),
      (_state, key: string) => key,
    ],
    (values, key) => get(values, key)
  );

export const getCommitedByKeySelector = (
  name: string,
  reducer: string = 'form'
) =>
  createDeepEqualSelector(
    [
      (state) => get(state, `${reducer}.${name}.commits`),
      (_state, key: string) => key,
    ],
    (commits, key) => get(commits, key)
  );
export const getLoadingByKeySelector = (
  name: string,
  reducer: string = 'form'
) =>
  createDeepEqualSelector(
    [
      (state) => get(state, `${reducer}.${name}.loading`),
      (_state, key: string) => key,
    ],
    (commits, key) => get(commits, key)
  );

export const getInitalTimeSelector = (name: string, reducer: string = 'form') =>
  createDeepEqualSelector(
    [(state) => get(state, `${reducer}.${name}.initalTime`)],
    (value) => value
  );

export const selectorFactory = (name: string, reducer: string = 'form') => ({
  getValues: getValuesSelector(name, reducer),
  getInitialValues: getInitialValuesSelector(name, reducer),
  getData: getDataSelector(name, reducer),
  getDataByKey: getDataByKeySelector(name, reducer),
  getCommitedByKey: getCommitedByKeySelector(name, reducer),
  getLoadingByKey: getLoadingByKeySelector(name, reducer),
  getInitalTime: getInitalTimeSelector(name, reducer),
});
